import React, { useState } from 'react';
import { getDateAsString } from '../../services/DateService';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { longLocationTypes } from '../../constants/LongLocationType';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { KOBOO_LIGHT_RED } from '../../constants/colors';
import { deleteLongLocationWaitingUser } from '../../store/lldWaitingUsers/actions';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';

const styles = () => (
  {
    buttonCell: {
      padding: 0,
      textAlign: 'center',
    },
  }
);

const LldWaitingUsersRow = (props) => {
  const { lldWaitingUser, openDialog, authUser, deleteLongLocationWaitingUser, classes } = props;
  const startDate = new Date(lldWaitingUser.start_date * 1000);
  const startDateString = getDateAsString(startDate);
  const createdDate = new Date(lldWaitingUser.created_at * 1000);
  const createdDateString = getDateAsString(createdDate);
  const lltCount = lldWaitingUser.lldCount;
  const lltType = lldWaitingUser.lldType;

  const [loading, setLoading] = useState(false);

  const deleteLldWaitingUser = () => {
    setLoading(true);
    deleteLongLocationWaitingUser(authUser.ma, lldWaitingUser.id);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    openDialog(
      'Suppression d\'une attente',
      'Êtes-vous certain de vouloir supprimer cette attente ?',
      () => deleteLldWaitingUser,
    );
  };

  return (
    <TableRow
      key={lldWaitingUser.id}
      hover
      tabIndex={-1}
    >
      <TableCell>
        {createdDateString}
      </TableCell>
      <TableCell>
        {lldWaitingUser.lastname}
      </TableCell>
      <TableCell>
        {lldWaitingUser.firstname}
      </TableCell>
      <TableCell>
        {lldWaitingUser.phone}
      </TableCell>
      <TableCell>
        {lldWaitingUser.city}
      </TableCell>
      <TableCell>
        {startDateString}
      </TableCell>
      <TableCell>
        {
          lltCount
          + ' '
          + longLocationTypes[lltType]
          + (
            (
              lltCount > 1 && lltType !== 'month'
            )
              ? 's'
              : ''
          )
        }
      </TableCell>
      {/* Bike availability not implemented yet
      <TableCell>
        Bike availability
      </TableCell>
      */}
      <TableCell className={classes.buttonCell}>
        {loading
          ? <CircularProgress />
          : <IconButton
            color="secondary"
            style={{ color: KOBOO_LIGHT_RED }}
            component="span"
            onClick={handleDelete}
          >
            <DeleteIcon />
          </IconButton>
        }
      </TableCell>
      {/* Empty TableCell to fill all the TableRow, need to find a fix */}
      <TableCell></TableCell>
    </TableRow>
  );
};

export default compose(
  connect(null, { deleteLongLocationWaitingUser }),
  withStyles(styles),
)(LldWaitingUsersRow);



// WEBPACK FOOTER //
// ./src/components/BookingsLld/LldWaitingUsersRow.jsx